export const DEVICES_BULK_PAIRING_OPEN_MODAL = "DEVICES_BULK_PAIRING_OPEN_MODAL";
export const DEVICES_BULK_PAIRING_CLOSE_MODAL = "DEVICES_BULK_PAIRING_CLOSE_MODAL";
export const DEVICES_BULK_PAIRING_REQUEST = "DEVICES_BULK_PAIRING_REQUEST";
export const DEVICES_BULK_PAIRING_RESULT = "DEVICES_BULK_PAIRING_RESULT";

export const DEVICES_BULK_PAIRING_SEARCH_DEVICES_REQUEST = "DEVICES_BULK_PAIRING_SEARCH_DEVICES_REQUEST";
export const DEVICES_BULK_PAIRING_SEARCH_DEVICES_RESULT = "DEVICES_BULK_PAIRING_SEARCH_DEVICES_RESULT";

export const DEVICES_BULK_PAIRING_SEARCH_ID_REQUEST = "DEVICES_BULK_PAIRING_SEARCH_ID_REQUEST";
export const DEVICES_BULK_PAIRING_SEARCH_ID_RESULT = "DEVICES_BULK_PAIRING_SEARCH_ID_RESULT";
